import {
  COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_BEGIN,
  COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_SUCCESS,
  COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_FAILURE,
  COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function importItemsFromRestApi(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_BEGIN,
    });
    const { projectId, version, collectionName, finalData } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/import-rest-api`,
        finalData,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_SUCCESS,
            data: res,
          });
          toast.success('Data Imported Successfully!');
          resolve(res);
        },
        (err) => {
          toast.error('Failed To Import !');
          dispatch({
            type: COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissImportItemsFromRestApiError() {
  return {
    type: COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_BEGIN:
      return {
        ...state,
        importItemsFromRestApiPending: true,
        importItemsFromRestApiError: null,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_SUCCESS:
      return {
        ...state,
        importItemsFromRestApiPending: false,
        importItemsFromRestApiError: null,
        responseData: null,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_FAILURE:
      return {
        ...state,
        importItemsFromRestApiPending: false,
        importItemsFromRestApiError: action.data.error,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_REST_API_DISMISS_ERROR:
      return {
        ...state,
        importItemsFromRestApiError: null,
      };

    default:
      return state;
  }
}
